import { ReactComponent as UserVerificationNeededImage } from "../../../../assets/UserVerificationNeeded.svg";
import { Translate, TranslateHtml } from "../../../Translation/Translate";
import TranslationKeys from "../../../../contexts/I18nContext/translationKeys";
import React from "react";
import { useNavigate } from "react-router";
import { VERIFICATION_URL_FOR_INDIVIDUAL } from "../../routing-constants";
import { GenericContentRestricted } from "../../shared/GenericContentRestricted";

interface UserVerificationNeededProps {
  isVerificationInReview: boolean;
  currentPath: string;
}

export const UserVerificationNeeded: React.FC<UserVerificationNeededProps> = ({
  isVerificationInReview,
  currentPath,
}) => {
  const navigate = useNavigate();

  return (
    <GenericContentRestricted
      image={<UserVerificationNeededImage />}
      title={
        <Translate
          translationKey={
            TranslationKeys.PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_TITLE
          }
        />
      }
      subtitle={
        <TranslateHtml
          translationKey={
            TranslationKeys.PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_SUBTITLE
          }
        />
      }
      comment={
        !isVerificationInReview && (
          <TranslateHtml
            translationKey={
              TranslationKeys.PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_COMMENT
            }
          />
        )
      }
      onCTAClick={() => navigate(VERIFICATION_URL_FOR_INDIVIDUAL(currentPath))}
      ctaText={
        isVerificationInReview ? undefined : (
          <Translate
            translationKey={
              TranslationKeys.PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_CTA
            }
          />
        )
      }
      alertText={
        isVerificationInReview ? (
          <Translate
            translationKey={
              TranslationKeys.PROFILE_CONTENT_RESTRICTED_USER_VERIFICATION_ALERT
            }
          />
        ) : undefined
      }
    />
  );
};
